import { ref, watch, computed,onMounted } from '@vue/composition-api'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axiosIns from '@/axios'
import store from '@/store'
import { useRouter } from '@core/utils/utils'

export default function useOrdersList() {
  // Use toast
  const toast = useToast()
  const { route } = useRouter() 

  const refOrderListTable = ref(null)

  const isFenomen = store.getters['user/isFenomen']

  // Table Handlers
  const tableColumns = [
    { key: 'id', sortable: true },
    { key: 'created_date', label: 'Sipariş Tarihi', sortable: true },
    { key: 'link', label: 'Paylaşım', sortable: true },
    { key: 'created_time', label: 'Sipariş Saati', sortable: true, tdClass:"text-center", thClass:"text-center" },
    { key: 'transaction', label: 'Sipariş No', sortable: true },
    { key: 'amount', label: 'Toplam', sortable: true },
    { key: 'payment_name', label: 'Ödeme Adı', sortable: true },
    { key: 'order_status', label: 'Sipariş Durumu', sortable: true },
    { key: 'vesting_status', label: 'Hakediş Durumu'},
    { key: 'show_details', label: 'DETAY'},
  ]
  if(!isFenomen && route.value.params.type === 'influencer'){
    tableColumns.splice(2, 0, { key: 'influencer', label: 'FENOMEN', sortable: true },);
  }else{
    tableColumns.splice(2, 0, { key: 'platform', label: 'Platform', sortable: true })
    tableColumns.splice(2, 0, { key: 'type', label: 'Kaynak', sortable: true })
  }
  

  const perPage = ref(store.state.appConfig.perPage)
  const totalOrders = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)
  const orderData = ref([])
  const isFirstLoad = ref(true)
  const additionalParams = ref({})

  const dataMeta = computed(() => {
    const localItemsCount = refOrderListTable.value ? refOrderListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalOrders.value,
    }
  })

  const refetchData = () => {
    refOrderListTable.value.refresh()
    fetchOrders();
  }

  watch([currentPage, perPage, searchQuery, roleFilter, planFilter, statusFilter, additionalParams, () => route.value.params] , () => {
    
   // additionalParams.value.filter nesnesinin tanımlı olup olmadığını kontrol edin, yoksa oluşturun
  if (!additionalParams.value.filter) {
    additionalParams.value.filter = {}; // Eğer filter yoksa, boş bir nesne olarak oluştur
  }

  // statusFilter değerine göre payment_status'u ekleyin veya silin
  if (statusFilter.value !== null && statusFilter.value !== undefined) {
    additionalParams.value.filter.payment_status = statusFilter.value; // id'yi ekle
  } else {
    delete additionalParams.value.filter.payment_status; // Null veya undefined ise payment_status'u sil
  }


    if (!isFirstLoad.value) { // İlk yüklemede değilse çalışsın
      refetchData()
    }
    isFirstLoad.value = false;
  })

  onMounted(() => {
    if(!additionalParams.value.hasFilter){ //eğer filtre olacaksa mounted da data çağırılmasın.
      fetchOrders();
    }
  });

  // Manuel sipariş durumunu güncelleme
  const orderStatus = ref({
      loading: false,
      last_date: store.state.user.customerInfo.order_last_update,
      getRemainingTime: null, // Başlangıçta kalan süreyi hesapla
  });

  // last_date'ı uygun bir formatta almak için bir fonksiyon
  const formatDatee = (dateString) => {
      if (!dateString) {
          return null; // dateString boşsa null döndür
      }
      return dateString.replace(' ', 'T') + 'Z'; // UTC formatına çevir
  };

  // Kalan süreyi hesaplayan fonksiyon
  const getRemainingTime = () => {
      const now = new Date();
      const formattedDate = formatDatee(orderStatus.value.last_date);
      if (!formattedDate) {
          return 'Tarih tanımlı değil'; // Eğer tarih formatlanamazsa bir mesaj döndür
      }

      const lastDate = new Date(formattedDate); // Formatla

      // lastDate'ın geçerli bir tarih olup olmadığını kontrol et
      if (isNaN(lastDate.getTime())) {
          return 'Geçersiz tarih';
      }

      // Eğer last_date, şu anki tarihten 3 saatten daha fazla uzaksa, last_date'i 3 saat ileri al
      const maxDuration = 3 * 60 * 60 * 1000; // 3 saat milisaniye cinsinden
      const timeDiff = lastDate.getTime() - now.getTime();

      if (timeDiff > maxDuration) {
          lastDate.setTime(now.getTime() + maxDuration); // last_date'i 3 saat ileri ayarla
      }

      // Kalan süreyi milisaniye cinsinden hesapla
      const remainingTime = lastDate.getTime() - now.getTime();

      // Eğer kalan süre sıfırdan küçükse, süre dolmuş demektir
      if (remainingTime <= 0) {
          return 'Süre dolmuş';
      }

      // Saat ve dakikaları hesapla
      const hours = Math.floor((remainingTime / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((remainingTime / (1000 * 60)) % 60);

      return `<b>${hours}</b> saat <b>${minutes}</b> dakika`;
  };

  
  if(!isFenomen){
    orderStatus.value.getRemainingTime = getRemainingTime();
    // Her saniyede bir kalan süreyi güncelle
    setInterval(() => {
        orderStatus.value.getRemainingTime = getRemainingTime();
    }, 1000);
  }

  const updateOrderStatus = () => {


    let url = '/order/updateOrderStatus'
    if(store.state.user.customerInfo.platform_id==3){
      url = '/order/updateTicimaxOrderStatus'
    }

    orderStatus.value.loading=true
    axiosIns
    .get(url)
    .then(response => {
      console.log(response.data)
      if(response.data.success){
        // Kullanıcı bilgilerini güncelle
        let updateCustomerInfo = {
            ...store.state.user.customerInfo,
            'order_last_update': response.data.last_date, // Yanıtla gelen tarihi güncelle
        };

        // Vuex store'unda kullanıcı bilgilerini güncelle
        store.commit('user/SET_CUSTOMER', updateCustomerInfo);
        orderStatus.value.last_date = response.data.last_date
        refetchData()
        toast({
          component: ToastificationContent,
          props: {
            title: response.data.message,
            icon: 'CheckCircleIcon',
            variant: 'success',
          },
        })
      }else{
        toast({
          component: ToastificationContent,
          props: {
            title: response.data.message,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
      
    })
    .catch(() => {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Manuel durum güncellemesinde hata',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    })
    .finally(() => {
      orderStatus.value.loading = false // Yükleme durumunu sonlandır
    })
  }

  const fetchOrders = () => {

    const params = {
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      role: roleFilter.value,
      plan: planFilter.value,
      typeOf: route.value.params.type,
      ...additionalParams.value
    };

    if(route.value.name=='orders'){
      params.source = 'olaylar'
    }

    axiosIns
      .get('/order', { params })
      .then(response => {
        const { Orders, total } = response.data.data;
        totalOrders.value = total;
        orderData.value = Orders;
      })
      .catch(error => {
        // 401 hatası değilse uyarı göster
        if (!error.response || error.response.status !== 401) {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Sipariş datası bulunmuyor.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        }
        reject(); // Hata durumunda reject çağırıyoruz
      });
  };

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'author') return 'warning'
    if (role === 'maintainer') return 'success'
    if (role === 'editor') return 'info'
    if (role === 'admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'subscriber') return 'UserIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveOrderstatusVariant = statusid => {
    if (statusid == '1' || statusid == '4') return 'warning'
    if (statusid == '3' || statusid == '7' || statusid == '8' || statusid == '12') return 'success'
    if (statusid == '2' || statusid == '11' || statusid == '1199' || statusid == '1201') return 'info'
    if (statusid == '9' || statusid == '10') return 'danger'
    return 'primary'
  }


  return {
    fetchOrders,
    updateOrderStatus,
    tableColumns,
    perPage,
    currentPage,
    totalOrders,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refOrderListTable,
    orderStatus,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveOrderstatusVariant,
    refetchData,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,

    additionalParams,

    orderData
  }
}
